import { useState } from 'react';

export default function BasicAutomations() {
  const [welcomeOn, setWelcomeOn] = useState(false);
  const [oooOn, setOooOn] = useState(false);
  const [delayedOn, setDelayedOn] = useState(false);
  const [iceBreakersOn, setIceBreakersOn] = useState(false);
  const [commandsOn, setCommandsOn] = useState(false);

  const [welcomeMsg, setWelcomeMsg] = useState('Welcome! How can we help you today?');
  const [oooMsg, setOooMsg] = useState('We are currently unavailable. We will get back to you soon.');
  const [delayedMsg, setDelayedMsg] = useState('Thanks for your message. Our team will respond shortly.');
  const [delayMinutes, setDelayMinutes] = useState(5);

  const [iceBreakers, setIceBreakers] = useState([
    { id: 1, text: 'View Products' },
    { id: 2, text: 'Track Order' },
    { id: 3, text: 'Contact Support' },
    { id: 4, text: 'Business Hours' }
  ]);

  const [commands, setCommands] = useState([
    { id: 1, command: '/support', hint: 'Get help from our team' },
    { id: 2, command: '/order', hint: 'Check order status' },
    { id: 3, command: '/pricing', hint: 'View our pricing' }
  ]);

  const toggle = (style) => ({
    width: 44, height: 24, borderRadius: 12, border: 'none', cursor: 'pointer',
    background: style ? '#25D366' : '#ccc', position: 'relative', transition: '0.2s'
  });

  const updateIceBreaker = (id, text) => {
    setIceBreakers(prev => prev.map(ib => ib.id === id ? { ...ib, text } : ib));
  };

  const updateCommand = (id, field, value) => {
    setCommands(prev => prev.map(cmd => cmd.id === id ? { ...cmd, [field]: value } : cmd));
  };

  return (
    <div>
      {/* Welcome Message */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 20, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: 15 }}>🔔 Welcome Message</div>
            <div style={{ color: '#6b7280', fontSize: 13, marginTop: 2 }}>Automatically sent when a new customer opens chat</div>
          </div>
          <button onClick={() => setWelcomeOn(v => !v)} style={toggle(welcomeOn)}>
            <span style={{ position: 'absolute', top: 3, left: welcomeOn ? 22 : 3, width: 18, height: 18, borderRadius: '50%', background: '#fff', transition: '0.2s' }} />
          </button>
        </div>
        {welcomeOn && (
          <textarea value={welcomeMsg} onChange={e => setWelcomeMsg(e.target.value)}
            rows={3} style={{ width: '100%', padding: '10px 12px', border: '1px solid #e0e0e0', borderRadius: 8, fontSize: 14, resize: 'vertical', boxSizing: 'border-box' }} />
        )}
      </div>

      {/* Out of Office */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 20, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: 15 }}>🌙 Out of Office (OOO)</div>
            <div style={{ color: '#6b7280', fontSize: 13, marginTop: 2 }}>Auto-reply when message received outside business hours</div>
          </div>
          <button onClick={() => setOooOn(v => !v)} style={toggle(oooOn)}>
            <span style={{ position: 'absolute', top: 3, left: oooOn ? 22 : 3, width: 18, height: 18, borderRadius: '50%', background: '#fff', transition: '0.2s' }} />
          </button>
        </div>
        {oooOn && (
          <textarea value={oooMsg} onChange={e => setOooMsg(e.target.value)}
            rows={3} style={{ width: '100%', padding: '10px 12px', border: '1px solid #e0e0e0', borderRadius: 8, fontSize: 14, resize: 'vertical', boxSizing: 'border-box' }} />
        )}
      </div>

      {/* Delayed Response */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 20, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: 15 }}>⏱️ Delayed Response</div>
            <div style={{ color: '#6b7280', fontSize: 13, marginTop: 2 }}>Send auto-reply after X minutes if no agent responds</div>
          </div>
          <button onClick={() => setDelayedOn(v => !v)} style={toggle(delayedOn)}>
            <span style={{ position: 'absolute', top: 3, left: delayedOn ? 22 : 3, width: 18, height: 18, borderRadius: '50%', background: '#fff', transition: '0.2s' }} />
          </button>
        </div>
        {delayedOn && (
          <>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 13, color: '#374151', fontWeight: 500, display: 'block', marginBottom: 6 }}>Delay (minutes)</label>
              <input type="number" value={delayMinutes} onChange={e => setDelayMinutes(e.target.value)}
                style={{ width: 120, padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: 8, fontSize: 14 }} />
            </div>
            <textarea value={delayedMsg} onChange={e => setDelayedMsg(e.target.value)}
              rows={3} style={{ width: '100%', padding: '10px 12px', border: '1px solid #e0e0e0', borderRadius: 8, fontSize: 14, resize: 'vertical', boxSizing: 'border-box' }} />
          </>
        )}
      </div>

      {/* Ice Breakers */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 20, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: 15 }}>🧊 Ice Breakers (Meta Conversational Components)</div>
            <div style={{ color: '#6b7280', fontSize: 13, marginTop: 2 }}>Tappable buttons shown when customer opens chat (Max 4, 80 chars each)</div>
          </div>
          <button onClick={() => setIceBreakersOn(v => !v)} style={toggle(iceBreakersOn)}>
            <span style={{ position: 'absolute', top: 3, left: iceBreakersOn ? 22 : 3, width: 18, height: 18, borderRadius: '50%', background: '#fff', transition: '0.2s' }} />
          </button>
        </div>
        {iceBreakersOn && (
          <div style={{ display: 'grid', gap: 10 }}>
            {iceBreakers.map((ib, idx) => (
              <div key={ib.id}>
                <label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 4 }}>Button {idx + 1}</label>
                <input 
                  type="text" 
                  value={ib.text} 
                  onChange={e => updateIceBreaker(ib.id, e.target.value)}
                  maxLength={80}
                  placeholder={`Ice breaker ${idx + 1}...`}
                  style={{ width: '100%', padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} 
                />
                <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>{ib.text.length}/80</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Commands */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 20, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: 15 }}>⌨️ Commands (Meta Conversational Components)</div>
            <div style={{ color: '#6b7280', fontSize: 13, marginTop: 2 }}>Shortcuts shown when customer types "/" in WhatsApp</div>
          </div>
          <button onClick={() => setCommandsOn(v => !v)} style={toggle(commandsOn)}>
            <span style={{ position: 'absolute', top: 3, left: commandsOn ? 22 : 3, width: 18, height: 18, borderRadius: '50%', background: '#fff', transition: '0.2s' }} />
          </button>
        </div>
        {commandsOn && (
          <div style={{ display: 'grid', gap: 12 }}>
            {commands.map((cmd, idx) => (
              <div key={cmd.id} style={{ border: '1px solid #f3f4f6', borderRadius: 8, padding: 12 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10 }}>
                  <div>
                    <label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 4 }}>Command</label>
                    <input 
                      type="text" 
                      value={cmd.command} 
                      onChange={e => updateCommand(cmd.id, 'command', e.target.value)}
                      placeholder="/command"
                      style={{ width: '100%', padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} 
                    />
                  </div>
                  <div>
                    <label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 4 }}>Description</label>
                    <input 
                      type="text" 
                      value={cmd.hint} 
                      onChange={e => updateCommand(cmd.id, 'hint', e.target.value)}
                      placeholder="What this command does..."
                      style={{ width: '100%', padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} 
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
<button
  onClick={() => {
    console.log("Saving...");
    alert("Saved successfully (demo)");
  }}
  style={{
    background: '#25D366',
    color: '#fff',
    border: 'none',
    padding: '10px 28px',
    borderRadius: 8,
    fontWeight: 600,
    cursor: 'pointer',
    fontSize: 14
  }}
>
  Save & Apply
</button>
</div>
);
}